//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../no/SelectDisplayableObject.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Angle",0,"Expression",0],[1,"EndBoundary",0,"SelectDisplayableObject",1],[0,"LengthAlignMethod",1,0],[1,"LengthParams",0,"Expression",0],[1,"MultipleSelectionEndBoundary",0,"SelectDisplayableObjectList",0],[0,"OrientationBySupport",1,0],[1,"RefParallelLine",0,"SelectNXObject",0],[0,"SetbackMethod",1,1],[0,"SetbackMethods",1,0],[1,"StartBoundary",0,"SelectDisplayableObjectList",0],[0,"StiffenerBySupportMethod",1,0],[0,"SwitchSide",1,0],[0,"ThroughPointLocation",1,"Point",0]],[[[],"ClearBoundaryToAttachedBoundaryMap",{},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Features.ShipDesign.StiffenerBySupportPathBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.StiffenerBySupportPathBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.StiffenerBySupportPathBuilder.Scenario = Object.freeze({
    "BasicDesign" : "BasicDesign", "DetailDesign" : "DetailDesign"});

SPLM.Features.ShipDesign.StiffenerBySupportPathBuilder.Method = Object.freeze({
    "AlignedBoundary" : "AlignedBoundary", "AlignedLength" : "AlignedLength", "BoundToBound" : "BoundToBound", "ParallelToLine" : "ParallelToLine", "Horizontal" : "Horizontal", "Vertical" : "Vertical", "NormalToCurve" : "NormalToCurve", "ThroughPoint" : "ThroughPoint"});

SPLM.Features.ShipDesign.StiffenerBySupportPathBuilder.AlignedTo = Object.freeze({
    "Web" : "Web", "Flange" : "Flange"});

SPLM.Features.ShipDesign.StiffenerBySupportPathBuilder.SetBackMethod = Object.freeze({
    "BoundingStiffenerHeight" : "BoundingStiffenerHeight", "SBSWebThickeness" : "SBSWebThickeness"});

SPLM.Features.ShipDesign.StiffenerBySupportPathBuilder.SetBackOption = Object.freeze({
    "BoundingStiffenerHeight" : "BoundingStiffenerHeight", "SbsWebThickness" : "SbsWebThickness"});

export default SPLM;